module.exports = __webpack_public_path__ + "img/Chaldal-logo.44cca4f2.png";